import axios from 'axios';
import _get from 'lodash/get';
import { isNewExpLayoutEnabled } from '../../helpers/twHelper';
import topicTreeJSONData from '../../../../server/data/topicTree/topicTree.json';
import Page from '../../../js/lib/page';

const WEB_TOPIC_TREE_URL = '/smarthelp/api/web-topic-tree';

// Constants
export const TOPIC_TREE_REQUESTED = 'TOPIC_TREE_REQUESTED';
export const TOPIC_TREE_SUCCESS = 'TOPIC_TREE_SUCCESS';
export const TOPIC_TREE_ERROR = 'TOPIC_TREE_ERROR';

const requestTopicTree = () => ({
  type: TOPIC_TREE_REQUESTED,
  payload: undefined,
});

const receivedTopicTree = (response, experience) => {
  const topics = _get(response, 'webTopicTree');
  return {
    type: TOPIC_TREE_SUCCESS,
    payload: {
      topics,
      experience,
    },
  };
};

const receivedTopicTreeError = () => ({
  type: TOPIC_TREE_ERROR,
});

export const fetchTopicTree = (experience) => (dispatch) => {
  dispatch(requestTopicTree());
  if (isNewExpLayoutEnabled()) {
    const topicTreeJson = topicTreeJSONData;
    return dispatch(receivedTopicTree(topicTreeJson, experience));
  }
  return axios
    .get(Page.setChannelForTechnicalExp(WEB_TOPIC_TREE_URL))
    .then((response) => dispatch(receivedTopicTree(response.data, experience)))
    .catch(() => {
      dispatch(receivedTopicTreeError());
    });
};
